import React from 'react';
import firebase from 'firebase';
import { Formik, Form } from 'formik';
import { object, string } from 'yup';
import TextField from '../components/TextField';

const RecoverPassword = ({ history }) => (
  <div className="row">
    <div className="col-xs-12 col-lg-6">
      <h3 className="page-header">Recover Password</h3>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={object().shape({
          email: string().email().required(),
        })}
        onSubmit={async ({ email }) => {
          try {
            await firebase.auth().sendPasswordResetEmail(email);
            alert('Successfully sent password reset email!');
            history.push('/login');
          } catch (error) {
            alert(error.message);
          }
        }}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <TextField type="email" label="Email Address" name="email" />
            <button type="submit" className="btn btn-primary">Send Reset Password Link</button>
          </Form>
        )}
      />
    </div>
  </div>
);

export default RecoverPassword;
